export default __webpack_public_path__ + "static/hero-nodes-de55b2084da8bec09182e44ecb0d68d3.png";